export const MaterialForm = {
  model: 'Material',
  format: [
    {
      widths: 'equal',
      fields: {
        name: {
          required: true,
          type: 'text',
          label: 'Material Name',
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        description: {
          required: true,
          type: 'text area',
          label: 'Material Description',
        },
      },
    },
  ],
}
